export const archive = {
  "ethPragueContentCollection": {
      "items": [
          {
              "pitchDeck": null,
              "hackathonText": null,
              "twitterLink": "https://twitter.com/EthPrague",
              "telegramLink": "https://t.me/ethprague",
              "applyToSpeakLabel": "See The Talks",
              "applyToSpeakLink": "https://youtube.com/playlist?list=PLkCRcxMT8qhZZC1ZcjuSu80FYHppongXo&si=5RaJ4BWkSf7yAzZh",
              "getTicketsLabel": null,
              "getTicketsLink": null,
              "applyToHackLabel": null,
              "applyToHackLink": null,
              "applyToVolunteerLabel": null,
              "applyToVolunteerLink": null,
              "getInTouchLabel": null,
              "getInTouchLink": null,
              "duckTapeLink": "https://ducttape.events/",
              "paralelniPolisLink": null,
              "isSectionFaqVisible": true,
              "faqWhatToExpectOnSiteLabel": "What to expect on site",
              "faqLocationLabel": "ETHGlobal Hackathon",
              "faqSleepAndRestLabel": "Location",
              "faqEthglobalHackathonLabel": "Side Events",
              "faq6Label": "Accommodation",
              "faq7Label": "Travel Tips",
              "faqAboutPragueLabel": "Tickets",
              "hackathonLabel": null,
              "faqWhatToExpectOnSiteText": {
                  "json": {
                      "data": {},
                      "content": [
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "The ETHPrague conference returns for its fourth edition at the repurposed Holešovice Market. This post-industrial venue features multiple buildings and stages with distinct vibes, along with community spaces and expansive outdoor areas, cafes, and galleries — perfect for socializing and networking. ",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "Attendees will find sponsor and supporter booths, snacks, and food trucks throughout the event venue. The conference program includes expert talks, panel discussions, and interactive workshops exploring environmental and social challenges and opportunities through innovative technology and collaboration, Solarpunk visions, and the latest developments in the Ethereum ecosystem. ",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "🕣 ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "Opening Hours",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "May 27, Tuesday: 9:00 - 19:00",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "May 28, Wednesday: 9:00 - 19:00",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "May 29, Thursday: 9:00 - 18:30",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "To see the vibes, pictures, and atmosphere from previous years, visit the ↗️",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://ducttapeevents.notion.site/ETHPrague-2024-Recap-1b41a305cfe7811da48ae4590a8ba574?pvs=4"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": "Recap",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": " articles.",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "Make sure to follow the event on ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://twitter.com/EthPrague"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": "X",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": ", ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://warpcast.com/ethprague"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": "Farcaster",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": ", ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://bsky.app/profile/ethprague.bsky.social"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": "Bluesky",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": ", and ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://hey.xyz/u/ethprague"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": "Hey",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": ", and join the ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://t.me/ethprague"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": "Telegram",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": " group chat for updates!",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "By attending the event, you agree to follow our ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "/1b41a305cfe780db818bd4776c6c3a69"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": "Code of Conduct",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": " and terms and conditions. Please review them before participating. ",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          }
                      ],
                      "nodeType": "document"
                  },
                  "links": {
                      "entries": {
                          "block": []
                      },
                      "assets": {
                          "block": []
                      }
                  }
              },
              "faqLocationText": {
                  "json": {
                      "data": {},
                      "content": [
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "Exciting news! Our amazing friends at ETHGlobal will be bringing one of their fantastic hackathons to Prague from May 30 to June 1, 2025! 🎉 ",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "This means ETHPrague can put all our passion and energy into creating an incredible conference experience for you, packed with inspiring sessions and technical workshops, featuring speakers and fascinating discussions about Ethereum and Solarpunk topics. While we won't be running our own hackathon this year, we're super excited about this collaboration and encourage you all to join the hackathon after the conference! ",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "Visit ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://ethglobal.com/events/prague"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": "ETHGlobal's website",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": " for more information and to apply to hack!",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          }
                      ],
                      "nodeType": "document"
                  },
                  "links": {
                      "entries": {
                          "block": []
                      },
                      "assets": {
                          "block": []
                      }
                  }
              },
              "faqSleepAndRestText": {
                  "json": {
                      "data": {},
                      "content": [
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "ETHPrague is returning to the spacious, repurposed Holešovice Market, filled with vibrant artistic and community spaces. After last year's success, we invite you again to explore this unique area with its cool post-industrial vibes, experience Prague's authentic character and rich history, and discover its hidden gems.",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "Address:",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://www.google.com/maps?ll=50.098925,14.446375&z=16&t=m&hl=cs&gl=CZ&mapclient=embed&q=50%C2%B005%2756.1%22N+14%C2%B026%2747.0%22E+50.098917,+14.446389@50.0989167,14.4463889"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": " Bubenské nábř. 306, 170 00 Praha 7-Holešovice, Czechia",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "See Location and Venue Maps below!",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "🕣 ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "Opening Hours",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "May 27, Tuesday: 9:00 - 19:00",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "May 28, Wednesday: 9:00 - 19:00",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "May 29, Thursday: 9:00 - 18:30",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          }
                      ],
                      "nodeType": "document"
                  },
                  "links": {
                      "entries": {
                          "block": []
                      },
                      "assets": {
                          "block": []
                      }
                  }
              },
              "faqEthglobalHackathonText": {
                  "json": {
                      "data": {},
                      "content": [
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "Check out our partners' curated lists of Web3 events in Prague this May/June",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "🔹 Connect with the broader ETHPrague community through ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://platform.serotonin.co/events?utm_medium=web&utm_source=ethprague"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": "Serotonin",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "'s comprehensive web3 events platform!",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "content": [
                                          {
                                              "data": {},
                                              "content": [
                                                  {
                                                      "data": {},
                                                      "marks": [],
                                                      "value": "Browse the full calendar of ",
                                                      "nodeType": "text"
                                                  },
                                                  {
                                                      "data": {
                                                          "uri": "https://platform.serotonin.co/events/eth-prague?utm_medium=web&utm_source=ethprague"
                                                      },
                                                      "content": [
                                                          {
                                                              "data": {},
                                                              "marks": [],
                                                              "value": "ETHPragueConf side events",
                                                              "nodeType": "text"
                                                          }
                                                      ],
                                                      "nodeType": "hyperlink"
                                                  },
                                                  {
                                                      "data": {},
                                                      "marks": [],
                                                      "value": ", mark yourself attending, and network with other participants before the conference begins!",
                                                      "nodeType": "text"
                                                  }
                                              ],
                                              "nodeType": "paragraph"
                                          }
                                      ],
                                      "nodeType": "list-item"
                                  },
                                  {
                                      "data": {},
                                      "content": [
                                          {
                                              "data": {},
                                              "content": [
                                                  {
                                                      "data": {},
                                                      "marks": [],
                                                      "value": "Event organizers can easily submit their side events to be included in the official calendar.",
                                                      "nodeType": "text"
                                                  }
                                              ],
                                              "nodeType": "paragraph"
                                          }
                                      ],
                                      "nodeType": "list-item"
                                  }
                              ],
                              "nodeType": "unordered-list"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "🔹 The ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://czechcryptoweek.com/"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [
                                                  {
                                                      "type": "bold"
                                                  }
                                              ],
                                              "value": "Czech Crypto Week",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": " is a local initiative, coordinated by the local community, and their platform also lists events happening in Prague. It's a leading blockchain and cryptocurrency event series, running from May 26 to June 1, 2025, featuring conferences, hackathons, workshops, and networking focused on blockchain innovation.",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          }
                      ],
                      "nodeType": "document"
                  },
                  "links": {
                      "entries": {
                          "block": []
                      },
                      "assets": {
                          "block": []
                      }
                  }
              },
              "faq6Text": {
                  "json": {
                      "data": {},
                      "content": [
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "Beautiful Prague offers many diverse accommodation options. We've teamed up with several partners to bring you fantastic discounts for your ETHPrague stay!",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "🅰️ ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "DeTrip",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "Browse through many accommodation options, and pay with 160+ cryptocurrencies or 16+ traditional payment methods and earn up to 10% crypto cashback in $USDC, $TRIP tokens, or other tokens! And that's not all! Book with a ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "20% discount",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": " (up to €50 per stay) for stays until June 10 using the exclusive discount code ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "ETHPRAGUE25 ",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "Ready? ↗️",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://detrip.travel/referrals/sign-up?ref=7B6FA445"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": "Create an account",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": ", start browsing (Book a Trip Now!), and make sure you enter the discount code ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "ETHPRAGUE25",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": " before you check out!",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "🅱️",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": " We've also secured unique discounts with some local hotels! (",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "italic"
                                          }
                                      ],
                                      "value": "Please note that these accommodation providers only accept traditional payment methods.)",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "🔸MAMA Shelter Prague",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": " (Address:",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://maps.app.goo.gl/XodydjeyJGp91aPm6"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": " Veletržní 1502/20, 170 00 Prague 7",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": ")",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "       10%",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": " discount ↗️",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://all.accor.com/lien_externe.svlt?goto=rech_resa&destination=B0X1&sourceid=M10OFF&dayIn=27&monthIn=05&yearIn=2025&nightNb=2&preferredCode=M10OFF&merchantid=par-accorFR"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": "Book Here",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "🔸Penta Hotel ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "(Address:",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://maps.app.goo.gl/syTK9yuJBSQUHeN6A"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": " Sokolovská 112, 186 00 Prague 8",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": ")",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "15% ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "discount ↗️",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://reservations.pentahotels.com/108140?identifier=GROUPDYN"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": "Book Here",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "🔸Plaza Prague Hotel ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "(Address:",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://maps.app.goo.gl/oWBVkSb4b6yxdLJ79"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": " Ortenovo nam. 22, 170 00 Prague 7",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": ")",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "25% ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "discount with code ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "ETHPrague2025",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": " ↗️",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://www.plazahotel.cz/en/booking-search/?date_in=2025-05-26&date_out=2025-05-30&adults=2&LanguageID=18&currency=EUR&promo=ETHPRAGUE2025"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": "Book Here",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "🔸Sir Toby's ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "(Address:",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://maps.app.goo.gl/NpULaLrYLur6ZpCQ6"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": " Delnická 24, 170 00 Prague 7",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": ")",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "15%",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": " discount with code ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "STAYFORLESS",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": " ↗️",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://sirtobys.com/"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": "Book Here",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          }
                      ],
                      "nodeType": "document"
                  },
                  "links": {
                      "entries": {
                          "block": []
                      },
                      "assets": {
                          "block": []
                      }
                  }
              },
              "faq7Text": {
                  "json": {
                      "data": {},
                      "content": [
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "Prague, the capital of the Czech Republic, is a beautiful city in the heart of Europe. Renowned for its rich history, stunning architecture, and vibrant culture, it's a destination that every traveler should experience.",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "We've put together a compact ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://ducttapeevents.notion.site/Prague-Guide-1fc1a305cfe78056816dc7613d44b207"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": "Guide",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": " with useful links for your exploring needs!",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          }
                      ],
                      "nodeType": "document"
                  },
                  "links": {
                      "entries": {
                          "block": []
                      },
                      "assets": {
                          "block": []
                      }
                  }
              },
              "faqAboutPragueText": {
                  "json": {
                      "data": {},
                      "content": [
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "The tickets are available via ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {
                                          "uri": "https://tix.ducttape.events/dt/ethpragueconf25/"
                                      },
                                      "content": [
                                          {
                                              "data": {},
                                              "marks": [],
                                              "value": "official ticket shop",
                                              "nodeType": "text"
                                          }
                                      ],
                                      "nodeType": "hyperlink"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": " only.",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "Ticket Waves & Pricing",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "• ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "Early-Bird",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": ": sold out",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "• ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "Discounted",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": ": 149 EUR (March 1 – April 15, or sold out)",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "• ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "Regular",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": ": 199 EUR (April 16 – until sold out)",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "• ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "Students",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": ": 100 free tickets, released in waves (25 each month) through application and selection",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "• ",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "Volunteers",
                                      "nodeType": "text"
                                  },
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": ": free tickets available subject to ongoing application and selection",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [],
                                      "value": "Tickets are not refundable and won't be available to buy on site.",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          }
                      ],
                      "nodeType": "document"
                  },
                  "links": {
                      "entries": {
                          "block": []
                      },
                      "assets": {
                          "block": []
                      }
                  }
              },
              "manifestoText": {
                  "json": {
                      "data": {},
                      "content": [
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "ETHPrague unites builders, thinkers, and visionaries to reaffirm blockchain's foundational ideals: decentralization, trustless collaboration, and open-access innovation. In an era of accelerating complexity, we return to cryptographic primitives, consensus mechanisms, and protocol-layer integrity — not as ends in themselves, but as tools to rearchitect societal systems for fairness, resilience, and sustainability.",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          },
                          {
                              "data": {},
                              "content": [
                                  {
                                      "data": {},
                                      "marks": [
                                          {
                                              "type": "bold"
                                          }
                                      ],
                                      "value": "\nTogether, we confront existential challenges — from centralized AI governance to climate instability. ETHPrague's mission is to steward community culture towards opening ourselves to outside criticism and facing crucial reality checks on what we build towards. The future remains unwritten. By grounding progress in Ethereum's bedrock principles, we choose neither dystopia nor utopia, but a protocol-powered realism — one where technology serves humanity's deepest needs, not its shallowest wants.",
                                      "nodeType": "text"
                                  }
                              ],
                              "nodeType": "paragraph"
                          }
                      ],
                      "nodeType": "document"
                  },
                  "links": {
                      "entries": {
                          "block": []
                      },
                      "assets": {
                          "block": []
                      }
                  }
              }
          }
      ]
  },
  "ethPraguePeopleSortedCollection": {
      "items": [
          {
              "ethPraguePeopleOrder2025Collection": {
                  "items": [
                      {
                          "sys": {
                              "id": "6LSq6MJOitizMRKcsOZO3X"
                          },
                          "name": "Tim Berners-Lee",
                          "twitter": "https://x.com/timberners_lee",
                          "company": "Inventor of the World Wide Web",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://3exwvbboowoktscrkc2jlytnurnzib4vm3dxcaots7yazvr4xxea.arweave.net/2S9qhC51nKnIUVC0leJtpFuUB5Vmx3EB05fwDNY8vcg",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "2ppNm4tV6u6L1oGrGXr8kP"
                          },
                          "name": "Vitalik Buterin",
                          "twitter": "https://twitter.com/VitalikButerin",
                          "company": "Ethereum Foundation",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://fjbyo4wwu2jeto4envyjjqy5i4h4jh7sibal6loa2qdar5djlbpa.arweave.net/KkOHctamkkm7hG1wlMMdRw_En_JAQL8twNQGCPRpWF4",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "4uilZtTLMlRKhRw7bTYNdV"
                          },
                          "name": "Christopher Fabian",
                          "twitter": "https://www.linkedin.com/in/hichrisfabian/?originalSubdomain=ch",
                          "company": "Giga, UNICEF",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://xn7mu2hcs2itrwfz77deahhegacsbygxb4l6ys7x5bi52jj45r2a.arweave.net/u37KaOKWkTjYuf_GQBzkMAUg4NcPF-xL9-hR3SU87HQ",
                          "profileImage": {
                              "sys": {
                                  "publishedAt": "2025-04-14T07:54:56.546Z",
                                  "id": "2ulmOu3Vsn2s2YiDlSf0RQ"
                              },
                              "fileName": "image.png",
                              "url": "https://images.ctfassets.net/6j1me6tz5h39/2ulmOu3Vsn2s2YiDlSf0RQ/2b2ba3cdec309b234fb1b363c0a0eca3/image.png"
                          }
                      },
                      {
                          "sys": {
                              "id": "3CR2ZYvg2qDwPLMAQ41hgT"
                          },
                          "name": "Aya Miyaguchi",
                          "twitter": "https://x.com/AyaMiyagotchi",
                          "company": "Ethereum Foundation",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://ueth.s3.us-west-2.amazonaws.com/public/prod/Aya_Miyaguchi.jpg",
                          "profileImage": {
                              "sys": {
                                  "publishedAt": "2025-04-14T07:56:03.107Z",
                                  "id": "1MTXpNFyHbhKR5Qqvpwwmi"
                              },
                              "fileName": "image.png",
                              "url": "https://images.ctfassets.net/6j1me6tz5h39/1MTXpNFyHbhKR5Qqvpwwmi/9c3ff00927ba11cc36fa5d729f383ca6/image.png"
                          }
                      },
                      {
                          "sys": {
                              "id": "3XPUpZYIshPWLwHcSJ5IBy"
                          },
                          "name": "Ondřej Kovařík",
                          "twitter": "https://x.com/okovarikmep?lang=en",
                          "company": "European Parliament",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://4hggqiivbd7flblfiic67l3j6n5uizzr264jo72quzov7tzqhkda.arweave.net/4cxoIRUI_lWFZUIF769p83tEZzHXuJd_UKZdX88wOoY",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "1OZS773VLpYyUfu4XAEnQc"
                          },
                          "name": "Tomasz Stanczak",
                          "twitter": "https://x.com/tkstanczak",
                          "company": "Ethereum Foundation",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://ethprague.com/Tomasz_Stanczak.jpg",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "4y8Wssd5MKAr5YaeLKddLj"
                          },
                          "profileImage": null,
                          "name": "Paul Brody",
                          "twitter": "https://www.linkedin.com/in/pbrody",
                          "company": "Ernst & Young",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Paul_Brody_-_EY_-__in_vibrant_cartoon_landscape__fgh5SiP.JPG"
                      },
                      {
                          "sys": {
                              "id": "6jvjucmTQx9MUlhXWCIT6T"
                          },
                          "name": "Tereza Bízková",
                          "twitter": "https://x.com/TerezaBizkova/",
                          "company": "Funding the Commons, ReFi Medellin, ReFi Podcast",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://ahwromcb37h4cpqxsl73reyluix5rdmsrsv2sgq7jq5aedr7upnq.arweave.net/Ae0XMEHfz8E-F5L_uJMLoi_YjZKMq6kaH0w6Ag4_o9s",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "1HZ12ymo4s3utQkl0fXBUe"
                          },
                          "name": "Josef Jelacic",
                          "twitter": "https://twitter.com/JosefJ_",
                          "company": "PWN DAO",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://ugbi34l2lkz6agmxuy577pdqo3pdgvsza35nphunelxkxiw5rqna.arweave.net/oYKN8Xpas-AZl6Y7_7xwdt4zVlkG-teejSLuq6LdjBo",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "68OQXz28TPXGQjy4dRKKDi"
                          },
                          "profileImage": null,
                          "name": "Tomas Mikolov",
                          "twitter": "https://www.linkedin.com/in/tomas-mikolov-59831188/?originalSubdomain=cz",
                          "company": "BottleCap AI",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/1585677320405_WgdBoKu.jpeg"
                      },
                      {
                          "sys": {
                              "id": "59Wvty8tDLRunXTFFoVLy5"
                          },
                          "name": "dcbuilder.eth",
                          "twitter": "https://x.com/dcbuild3r",
                          "company": "WORLD FOUNDATION",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://pbs.twimg.com/profile_images/1630352089569280003/PnFV0u3W_400x400.jpg",
                          "profileImage": {
                              "sys": {
                                  "publishedAt": "2025-04-15T09:49:05.968Z",
                                  "id": "1MuhUeaD9waY7xTjPnVJKB"
                              },
                              "fileName": "DCBuilder.png",
                              "url": "https://images.ctfassets.net/6j1me6tz5h39/1MuhUeaD9waY7xTjPnVJKB/182b8b58187a2c52e4f9d1b4103a5808/DCBuilder.png"
                          }
                      },
                      {
                          "sys": {
                              "id": "41w0OO9QerbAvrptl9ty7W"
                          },
                          "name": "Nicolas Consigny",
                          "twitter": "https://x.com/ncsgy",
                          "company": "Ethereum Foundation",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://3bwhqhzprkl7boa2johs6p3jecp4lka2tzpzyckvipti664e72da.arweave.net/2Gx4Hy-Kl_C4GkuPLz9pIJ_FqBqeX5wJVUPmj3uE_oY",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "2vqqLCdN6g9wV5dHisGkYC"
                          },
                          "profileImage": null,
                          "name": "Alex Gluchowski",
                          "twitter": "https://www.linkedin.com/in/gluchowski/?originalSubdomain=cy",
                          "company": "Matter Labs",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://iq.wiki/cdn-cgi/image/width=1920,quality=70/https://ipfs.everipedia.org/ipfs/QmfPSZRA144Dmu7w8uencQcYBeKJPDhX5im5c42Lr8bHJ7"
                      },
                      {
                          "sys": {
                              "id": "2cMhfbqUZbfEDby72vYdZH"
                          },
                          "name": "cheeky gorilla",
                          "twitter": "https://x.com/cheekygorilla0x",
                          "company": "Protocol Guild",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://yfyqsd523l525g5tm277fng6hwfjxov6bvuqmrpxewyg4i3ooroa.arweave.net/wXEJD7ra-66bs2a_8rTePYqbur4NaQZF9yWwbiNudFw",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "2frvB3ggN8mfCEnNEhk8JF"
                          },
                          "name": "Kevin Jones",
                          "twitter": "https://x.com/cryptomastery_",
                          "company": "The Graph, Buidl Guidl",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://v3eozvm72vef3bjw2zrp6h5yi6nw2v5chfu553ftl6er3fftl4mq.arweave.net/rsjs1Z_VSF2FNtZi_x-4R5ttV6I5ad7ss1-JHZSzXxk",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "Wb076RLIkMruklV0TCdpU"
                          },
                          "profileImage": null,
                          "name": "Joachim Schwerin",
                          "twitter": null,
                          "company": "European Commission",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Foto_Joachim_Schwerin_Cp0wzzq.jpg"
                      },
                      {
                          "sys": {
                              "id": "1D6tDznf5a00OOAnLKGEfX"
                          },
                          "name": "Jordi Baylina",
                          "twitter": "https://x.com/jbaylina",
                          "company": "Polygon zkEVM",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://syjbitorc2tgmogmfcsdpa2oyfzxanffgzch6hk7toekhsxyrhia.arweave.net/lhIUTdEWpmY4zCikN4NOwXNwNKU2RH8dX5uIo8r4idA",
                          "profileImage": {
                              "sys": {
                                  "publishedAt": "2025-04-14T07:43:15.685Z",
                                  "id": "4M3xQ3LWqHHriW46oMvZUJ"
                              },
                              "fileName": "jordi3_400_I860VrL.jpg",
                              "url": "https://images.ctfassets.net/6j1me6tz5h39/4M3xQ3LWqHHriW46oMvZUJ/7bb3ed91c118f686654d5a0172d4271d/jordi3_400_I860VrL.jpg"
                          }
                      },
                      {
                          "sys": {
                              "id": "610kuu47nM51sF09HiZYhx"
                          },
                          "profileImage": null,
                          "name": "Maya Dotan",
                          "twitter": "https://x.com/MayaD09111862",
                          "company": "StarkWare",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Screenshot_2025-04-23_at_9.27.42_uJaTeyz.png"
                      },
                      {
                          "sys": {
                              "id": "79VgkVF7Dijrai558kRdps"
                          },
                          "name": "Austin Griffith",
                          "twitter": "https://x.com/austingriffith",
                          "company": "BuidlGuidl",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://pbs.twimg.com/profile_images/1484336102693490689/bmhym86N_400x400.jpg",
                          "profileImage": {
                              "sys": {
                                  "publishedAt": "2025-04-14T08:01:32.182Z",
                                  "id": "Npj5HQwCGgHKZB4KqEbMt"
                              },
                              "fileName": "image.png",
                              "url": "https://images.ctfassets.net/6j1me6tz5h39/Npj5HQwCGgHKZB4KqEbMt/7d52ab39df0db6d811d106259f4fdd7f/image.png"
                          }
                      },
                      {
                          "sys": {
                              "id": "2WJCfctKvLHhXWJVPfUCQ9"
                          },
                          "name": "Dr. Maurice Chiodo",
                          "twitter": "https://www.mauricechiodo.com",
                          "company": "Centre for the Study of Existential Risk",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://pdvch74pqrgbidue2sp27lx5sved34vxpik3qtrtl6wymboewg7a.arweave.net/eOoj_4-ETBQOhNSfr679lUg98rd6FbhOM1-thgXEsb4",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "GcgWKS04vWYwKjTUDGZZk"
                          },
                          "profileImage": null,
                          "name": "Andrew Koller",
                          "twitter": "https://x.com/ak47ink",
                          "company": "Ink",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/GkqJzKObkAAgLCj-2_4CPVYCi.jpg"
                      },
                      {
                          "sys": {
                              "id": "2srq5fjRnMpRKlGwMriOT6"
                          },
                          "name": "Jerome de Tychey",
                          "twitter": "https://x.com/jdetychey",
                          "company": "Cometh, Ethereum France",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://pbs.twimg.com/profile_images/1640656157319503874/hhSF15yA_400x400.jpg",
                          "profileImage": {
                              "sys": {
                                  "publishedAt": "2025-04-14T07:53:34.777Z",
                                  "id": "1cgKLYswCUBcx5abHuvCxD"
                              },
                              "fileName": "image.png",
                              "url": "https://images.ctfassets.net/6j1me6tz5h39/1cgKLYswCUBcx5abHuvCxD/9bcd0f93ddb740a461422ce9ba64fb64/image.png"
                          }
                      },
                      {
                          "sys": {
                              "id": "4thlCdRBIQrs9KdGGIzlbG"
                          },
                          "name": "Jakub Konopka",
                          "twitter": "https://x.com/asbet0s?lang=nb",
                          "company": "Ethereum Foundation",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://pbs.twimg.com/profile_images/1522166884233265152/r-ezwXXC_400x400.jpg",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "DQ2nopP26ipkLeOdTwG2p"
                          },
                          "profileImage": null,
                          "name": "Wessel Reijers",
                          "twitter": "https://www.wesselreijers.nl/research/",
                          "company": "Paderborn University",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://jgjqf42ps7ewbhhbr7js5srgj3rsy7gatvkjx2b7wav6wasp52xq.arweave.net/SZMC80-XyWCc4Y_TLsomTuMsfMCdVJvoP7Ar6wJP7q8"
                      },
                      {
                          "sys": {
                              "id": "21N07iFYIjbBDXbKRQoEpC"
                          },
                          "profileImage": null,
                          "name": "Nader Dabit",
                          "twitter": "https://x.com/dabit3",
                          "company": "EigenLayer",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://pbs.twimg.com/profile_images/1795944646754861056/BvLWDVYq_400x400.jpg"
                      },
                      {
                          "sys": {
                              "id": "4VRwvBQTwnhozcGwreYvdF"
                          },
                          "profileImage": null,
                          "name": "Tess Rinearson",
                          "twitter": "https://x.com/_tessr",
                          "company": "OP Labs",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/TceumiCw_400x400_JVhFLxt.jpg"
                      },
                      {
                          "sys": {
                              "id": "1nNzcbBJ9AN0jkXr3UmUQw"
                          },
                          "name": "John Lilic",
                          "twitter": "https://x.com/LilicJohn",
                          "company": "Never Local",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://csu57mtpdywgystv4rfwbrcwtfc6oolyzhws4hvnwos3kcavnv2q.arweave.net/FKnfsm8eLGxKdeRLYMRWmUXnOXjJ7S4erbOltQgVbXU",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "5TV6Nh0sVs13vBnjIe2tKe"
                          },
                          "name": "Anika Nicolaas Ponder",
                          "twitter": "https://www.linkedin.com/in/anika-nicolaas-ponder-295b0239/",
                          "company": "IKEM",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://jfotdnifyfwroshi3m6smdr6rbzldqdauadd2tdllhybajivl7sa.arweave.net/SV0xtQXBbRdI6Ns9Jg4-iHKxwGCgBj1Ma1nwECUVX-Q",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "v8IUzs7uzJcj1a8gkncFl"
                          },
                          "name": "Mario",
                          "twitter": "https://twitter.com/TMIYChao",
                          "company": "Ethereum Foundation",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://v45lrsjzxthg6wvytvdutmmcqbvvmkpdrh7jskzabzpecemimltq.arweave.net/rzq4yTm8zm9auJ1HSbGCgGtWKeOJ_pkrIA5eQRGIYuc",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "6pfdYE2PNQZoyibaYb0fDe"
                          },
                          "name": "Simon Mohn",
                          "twitter": "https://www.linkedin.com/in/simon-mohn-24180217b/en",
                          "company": "Reinventing society",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://j73rje3chgbb6xhabpjf4vf3tp7lreyzaa3bazgy3oi53za3j42a.arweave.net/T_cUk2I5gh9c4AvSXlS7m_64kxkANhBk2NuR3eQbTzQ",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "3S9vEoHpyIsSmT8FoG7IfG"
                          },
                          "profileImage": null,
                          "name": "Patrick McCorry",
                          "twitter": "https://twitter.com/stonecoldpat0",
                          "company": "Arbitrum Foundation",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/anime_ezxbgin.jpg"
                      },
                      {
                          "sys": {
                              "id": "7eQ9vaxy9JhAQLwo6Dkuwj"
                          },
                          "name": "Martin Warnke",
                          "twitter": "https://www.ifk.ac.at/fellows-detail/martin-warnke-2.html",
                          "company": "Leuphana University Lüneburg",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://o5uy5penpzc3fbj23vbvdsb7z2ci6prq25i3il2i7lqszf23jpfq.arweave.net/d2mOvI1-RbKFOt1DUcg_zoSPPjDXUbQvSPrhLJdbS8s",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "16GNTPiG9QoQ0Kgz3V9W2T"
                          },
                          "profileImage": null,
                          "name": "Hira Siddiqui",
                          "twitter": "https://www.linkedin.com/in/hira-siddiqui-96b60a74/",
                          "company": "Plurality Network",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/hira_QiM5lTN.jpg"
                      },
                      {
                          "sys": {
                              "id": "6mCVEk147jwJWeLbEKQPzl"
                          },
                          "name": "Bernd Riedel",
                          "twitter": "https://www.linkedin.com/in/bernd-riedel/",
                          "company": "Ellery Studio\t",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://fyij72z4f5nau2vxzradcfyq3x4mhntf7f3h6mkg3ymnnhqd5nqa.arweave.net/LhCf6zwvWgpqt8xAMRcQ3fjDtmX5dn8xRt4Y1p4D62A",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "145Ia95ptU0RaxAdB9nWKr"
                          },
                          "profileImage": null,
                          "name": "Stephen Ajayi",
                          "twitter": "https://x.com/5m477",
                          "company": "Hacken",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/IMG_7803_KW8cGm8.jpg"
                      },
                      {
                          "sys": {
                              "id": "5zdwnj4L1Ht8WgmhIAJxo8"
                          },
                          "name": "Leo BG",
                          "twitter": "https://x.com/miga_labs",
                          "company": "MigaLabs",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://7yneud5plfrjbqcesvgco5fbxbskko5you2cm26raf7f4wzpr4na.arweave.net/_hpKD69ZYpDARJVMJ3ShuGSlO7h1NCZr0QF-Xlsvjxo",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "4YqA4ZCueow9MxNZbGchM0"
                          },
                          "name": "Dàmir Belltheus Avdic",
                          "twitter": "https://www.linkedin.com/in/damirbelltheusavdic/?originalSubdomain=de",
                          "company": "IKEM",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://rh2u36vf5qllb3ya4vrdyn3zcowf6pd7tajjarbk7smc3aq6prcq.arweave.net/ifVN-qXsFrDvAOViPDd5E6xfPH-YEpBEKvyYLYIefEU",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "24kQCWpcY5ktB8frPT3RqH"
                          },
                          "name": "Sara Polak",
                          "twitter": "https://x.com/_sara_polak",
                          "company": "Mobilis Institute",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://zr6npltaolplcmafkfakm5sntk5r7wnjfva5gbik5fc2byoaxxea.arweave.net/zHzXrmBy3rEwBVFApnZNmrsf2aktQdMFCulFoOHAvcg",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "515FhhH4eziEpu5JqEgfWb"
                          },
                          "profileImage": null,
                          "name": "Viktor Tron",
                          "twitter": "https://x.com/zeligf",
                          "company": "Swarm Foundation",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/headshot_2023-04-26_at_18.44.18_9WApT4O.jpeg"
                      },
                      {
                          "sys": {
                              "id": "2LW2gS4uAxTbxEm4yVQTEi"
                          },
                          "profileImage": null,
                          "name": "Vugar Usi Zade",
                          "twitter": "https://www.linkedin.com/in/usithetalk/?originalSubdomain=uk",
                          "company": "Bitget",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://oodrbhxkeskdf25wbhzh6w3x5jtgr2nftavh63tptyiwiysw2inq.arweave.net/c4cQnuoklDLrtgnyf1t36mZo6aWYKn9ub54RZGJW0hs"
                      },
                      {
                          "sys": {
                              "id": "1iIE9flOslcJDwf7C71myC"
                          },
                          "name": "Maciej Zygmunt",
                          "twitter": "https://x.com/0xZygmunt ",
                          "company": "L2BEAT",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://k2h77lycxcav2fj3zss3k7ts7ma2y3egsdncwunynqnpclt47c5q.arweave.net/Vo__rwK4gV0VO8yltX5y-wGsbIaQ2itRuGwa8S58-Ls",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "1u5xAousu12kFtEu0Jxmjj"
                          },
                          "name": "Miguel Palhas",
                          "twitter": "https://x.com/naps62",
                          "company": "Subvisual, ethui.dev",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://xlxv22axyxcdufg4halkk4xjc37mv2pubffsug3vjzvj6py4qrhq.arweave.net/uu9daBfFxDoU3DgWpXLpFv7K6fQJSyobdU5qnz8chE8",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "127KpTdlTTW1jquD3GCVom"
                          },
                          "profileImage": null,
                          "name": "vrn.eth",
                          "twitter": "http://x.com/vrneth",
                          "company": "Zuitzerland",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/propic_hMC5gFb.jpg"
                      },
                      {
                          "sys": {
                              "id": "1qGqa6v0hfHsc6Wzr1du2k"
                          },
                          "name": "Aleksejs Ivashuk",
                          "twitter": "https://x.com/ApatrideNetwork",
                          "company": "Apatride Network",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/IMG_20230919_214818_030_iBbs6Gx.jpg",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "7zMju39cdkRG6e0LZfAP9m"
                          },
                          "name": "Uttam Singh",
                          "twitter": "https://x.com/uttam_singhk",
                          "company": "Alchemy",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://zkjz5fm7l5iix44u5hufgnk7qiwq4t6huxkko3zoqtgdejv5od7a.arweave.net/ypOelZ9fUIvzlOnoUzVfgi0OT8el1KdvLoTMMia9cP4",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "3UGIweuAwBOm9n5Due9ro1"
                          },
                          "name": "Lukas",
                          "twitter": "https://github.com/NumberFour8",
                          "company": "HOPR",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/avatar_12.06.52_ixmwiPR.jpg",
                          "profileImage": {
                              "sys": {
                                  "publishedAt": "2025-04-17T14:19:31.182Z",
                                  "id": "3uTPEBEEZByIosPcQTVjcS"
                              },
                              "fileName": "avatar_12.06.52_ixmwiPR.png",
                              "url": "https://images.ctfassets.net/6j1me6tz5h39/3uTPEBEEZByIosPcQTVjcS/347eac3b63ba1e6bf4ac0d9f6138e88f/avatar_12.06.52_ixmwiPR.png"
                          }
                      },
                      {
                          "sys": {
                              "id": "1Vzcjx5YBuxoUyVeZSidlo"
                          },
                          "name": "Brenda Loya",
                          "twitter": "https://x.com/JustBrendax",
                          "company": "Tellor",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Copy_of_BrendaLoyaHeadshot_aQgBwPq.jpeg",
                          "profileImage": {
                              "sys": {
                                  "publishedAt": "2025-04-17T14:26:50.229Z",
                                  "id": "4o08XupwV7ztyvSvd1JjGw"
                              },
                              "fileName": "Brenda Loya.jpeg",
                              "url": "https://images.ctfassets.net/6j1me6tz5h39/4o08XupwV7ztyvSvd1JjGw/0c70c91e1068a6edd530dea6489270dc/Brenda_Loya.jpeg"
                          }
                      },
                      {
                          "sys": {
                              "id": "2R8b3nKt1Rkct9ml5FTv41"
                          },
                          "profileImage": null,
                          "name": "Georgy Sokolov",
                          "twitter": "https://www.linkedin.com/in/georgysokolov/",
                          "company": "Wirex",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/GS_small_kNpca0K.jpg"
                      },
                      {
                          "sys": {
                              "id": "1cerTwM4xWjORNg4qRD4XE"
                          },
                          "name": "Miao ZC",
                          "twitter": "https://github.com/hellwolf",
                          "company": "Superfluid Foundation, Yolc",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/miao-2023-sketch-plus-urbit_LUIWFhZ.png",
                          "profileImage": {
                              "sys": {
                                  "publishedAt": "2025-04-17T14:20:03.780Z",
                                  "id": "JxxN1mJuM0Ds75UgI2Lbg"
                              },
                              "fileName": "miao-2023-sketch-plus-urbit_3XLDkFK.png",
                              "url": "https://images.ctfassets.net/6j1me6tz5h39/JxxN1mJuM0Ds75UgI2Lbg/0c66ab5093d7b3b0df33fc6941f71739/miao-2023-sketch-plus-urbit_3XLDkFK.png"
                          }
                      },
                      {
                          "sys": {
                              "id": "6MegHujwt8hOlkhe2HDy8u"
                          },
                          "name": "Noah Jelich",
                          "twitter": "https://www.linkedin.com/in/njelich/",
                          "company": "Independent",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/1708734153408_RJ1p5Vm.jpg",
                          "profileImage": {
                              "sys": {
                                  "publishedAt": "2025-04-17T14:21:43.913Z",
                                  "id": "31j63FmInwED3vbbTrl6Z8"
                              },
                              "fileName": "1708734153408_RJ1p5Vm.jpg",
                              "url": "https://images.ctfassets.net/6j1me6tz5h39/31j63FmInwED3vbbTrl6Z8/0a9102c40e26cdd6ad9d151a9ab93146/1708734153408_RJ1p5Vm.jpg"
                          }
                      },
                      {
                          "sys": {
                              "id": "43NtAqfzwk2X5LLzcXKfJQ"
                          },
                          "profileImage": null,
                          "name": "Anthony Leuts",
                          "twitter": "https://x.com/A_Leutenegger",
                          "company": "Aragon",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Anthony_Leutenegger_YONMAVm.jpg"
                      },
                      {
                          "sys": {
                              "id": "322AZRXvu31yWl9lIy7iMI"
                          },
                          "name": "Shantanu Sontakke",
                          "twitter": "https://x.com/shanzson",
                          "company": "zokyo",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/IMG_3974_cGbBRGf.jpeg",
                          "profileImage": {
                              "sys": {
                                  "publishedAt": "2025-04-17T14:42:46.858Z",
                                  "id": "1UcawdtDA3ric4lhyKBd62"
                              },
                              "fileName": "image.png",
                              "url": "https://images.ctfassets.net/6j1me6tz5h39/1UcawdtDA3ric4lhyKBd62/84d08aeee1a108d2e43a7b8d971ec8e9/image.png"
                          }
                      },
                      {
                          "sys": {
                              "id": "1yXNBzuFzywMXr1VEIeUXq"
                          },
                          "name": "Rica Amaral",
                          "twitter": "https://www.google.com/url?sa=t&source=web&rct=j&opi=89978449&url=https://twitter.com/ricaa&ved=2ahUKEwiCi_jro9-MAxWD77sIHUBWBUoQFnoECA0QAQ&usg=AOvVaw0jjVgi2qI1vfQmWIDrIRhi",
                          "company": "Celo EU",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Rica-orb-pfp-dark_FuWVBLc.jpg",
                          "profileImage": {
                              "sys": {
                                  "publishedAt": "2025-04-17T14:42:09.433Z",
                                  "id": "6Y3mNYMvmNI94M0SzqivJC"
                              },
                              "fileName": "image.png",
                              "url": "https://images.ctfassets.net/6j1me6tz5h39/6Y3mNYMvmNI94M0SzqivJC/dbd0b36f5e13b4777658ebdeeeb99e27/image.png"
                          }
                      },
                      {
                          "sys": {
                              "id": "4iTdMPEzxqUr3pe5dIB1Zr"
                          },
                          "name": "Laurence Kirk",
                          "twitter": "https://x.com/extropy?lang=en",
                          "company": "Extropy.IO",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/e5ecaf7b4fa490013bd899069491c5d2_Xbbhdok.jpg",
                          "profileImage": {
                              "sys": {
                                  "publishedAt": "2025-04-17T14:28:29.292Z",
                                  "id": "4v90YQ1odZdJL7qvFvLK5u"
                              },
                              "fileName": "e5ecaf7b4fa490013bd899069491c5d2.jpeg",
                              "url": "https://images.ctfassets.net/6j1me6tz5h39/4v90YQ1odZdJL7qvFvLK5u/2caf5e2b76d4e00d1fa87a82974aadf3/e5ecaf7b4fa490013bd899069491c5d2.jpeg"
                          }
                      },
                      {
                          "sys": {
                              "id": "FUvPTVerpUF97lBmMWXON"
                          },
                          "name": "Katarzyna Kiwalska",
                          "twitter": "https://www.linkedin.com/in/katarzyna-kiwalska-6a89648/",
                          "company": "Rohlik Group",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/KKiwalska_photo_oTAogn9.jpg",
                          "profileImage": {
                              "sys": {
                                  "publishedAt": "2025-04-17T14:45:05.366Z",
                                  "id": "1lXS1mN2mAGC6YUYNAqXEf"
                              },
                              "fileName": "image.png",
                              "url": "https://images.ctfassets.net/6j1me6tz5h39/1lXS1mN2mAGC6YUYNAqXEf/771c4b14865ad8de2589fad6a992acaf/image.png"
                          }
                      },
                      {
                          "sys": {
                              "id": "64wMoCUkRJlmIPqY8OcnE5"
                          },
                          "name": "Eugenio Reggianini",
                          "twitter": "https://www.linkedin.com/in/eugenio-reggianini-a9a572a4?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
                          "company": "European Blockchain Association",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://tokensummit.li/files/uploads/Token%20Summit/Speakers/Speakers_2023/eugenio_reggianini.png",
                          "profileImage": {
                              "sys": {
                                  "publishedAt": "2025-04-17T14:32:44.352Z",
                                  "id": "4NI6ElyRhqf9LgMiLuxDrg"
                              },
                              "fileName": "image.png",
                              "url": "https://images.ctfassets.net/6j1me6tz5h39/4NI6ElyRhqf9LgMiLuxDrg/e8873050c49ff769de7bb9db719a416c/image.png"
                          }
                      },
                      {
                          "sys": {
                              "id": "50hEYX1jU9qIpMG4XZ6OcZ"
                          },
                          "name": "Liam Mcmaster",
                          "twitter": null,
                          "company": "LinumLabs",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://b3a3ma43bkijlqizhfuiw6l7quckxxb5socxcfluu73wvl5zsuwq.arweave.net/DsG2A5sKkJXBGTloi3l_hQSr3D2ThXEVdKf3aq-5lS0",
                          "profileImage": {
                              "sys": {
                                  "publishedAt": "2025-04-17T14:38:43.706Z",
                                  "id": "6z5KmcEckNdUplFCCVNgrZ"
                              },
                              "fileName": "image.png",
                              "url": "https://images.ctfassets.net/6j1me6tz5h39/6z5KmcEckNdUplFCCVNgrZ/b9c00825b3c4d56415dc9ac447beb8ea/image.png"
                          }
                      },
                      {
                          "sys": {
                              "id": "16grPjRSpGe2U6nEhGPD1m"
                          },
                          "name": "Tomas Studenik",
                          "twitter": "https://www.linkedin.com/in/studenik",
                          "company": "Insane Business Ideas Ltd.",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/IMG_6885_ZSLZSlr.jpeg",
                          "profileImage": {
                              "sys": {
                                  "publishedAt": "2025-04-17T14:41:20.658Z",
                                  "id": "1SIlfegHd73fvXHuy25Yau"
                              },
                              "fileName": "image.png",
                              "url": "https://images.ctfassets.net/6j1me6tz5h39/1SIlfegHd73fvXHuy25Yau/ff27275459e11e4bec3a97a78f734994/image.png"
                          }
                      },
                      {
                          "sys": {
                              "id": "6EtaZjswcz2VuKpB17perL"
                          },
                          "profileImage": null,
                          "name": "Carles Cerqueda",
                          "twitter": " https://www.linkedin.com/in/carles-cerq/",
                          "company": "Cambridge Centre for Alternative Finance",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Captura_de_pantalla_2025-04-10_000814_Pengvdo.png"
                      },
                      {
                          "sys": {
                              "id": "2q3FlN4HdcY64WTCeJ8xu9"
                          },
                          "profileImage": null,
                          "name": "Renaud Dubois",
                          "twitter": "https://x.com/RenaudDUBOIS10",
                          "company": "ZKNOX",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Renaud_Dubois_j7NMvBt.jpg"
                      },
                      {
                          "sys": {
                              "id": "14SBhScQvOXpc4Ny6xAiTV"
                          },
                          "name": "mf (michiel)",
                          "twitter": "https://x.com/0x_m_f",
                          "company": "Web3Privacy Now ",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/mfprofile_ddngV37.jpg",
                          "profileImage": {
                              "sys": {
                                  "publishedAt": "2025-04-17T14:22:59.685Z",
                                  "id": "2nUgTyGRKyb0m9eW9ho7ZO"
                              },
                              "fileName": "image.png",
                              "url": "https://images.ctfassets.net/6j1me6tz5h39/2nUgTyGRKyb0m9eW9ho7ZO/5e7111ede89fd0ea903e200685897c25/image.png"
                          }
                      },
                      {
                          "sys": {
                              "id": "2cFGWIerOQR84pgtAmwJJo"
                          },
                          "profileImage": null,
                          "name": "Eylon",
                          "twitter": "https://x.com/theEylon",
                          "company": "Collider",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/profile_pic2_33bMb0x.jpg"
                      },
                      {
                          "sys": {
                              "id": "5uLQVyY9QaGVSXr0PQ3GjF"
                          },
                          "name": "Lauren Gilbert",
                          "twitter": "http://lgilbert.co",
                          "company": "Renaissance Philanthropy",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Screenshot_2025-04-01_at_14.45.12_BL8AYWF.png",
                          "profileImage": {
                              "sys": {
                                  "publishedAt": "2025-04-17T14:43:42.005Z",
                                  "id": "37P88JopvI5BKSvrAozvLN"
                              },
                              "fileName": "image.png",
                              "url": "https://images.ctfassets.net/6j1me6tz5h39/37P88JopvI5BKSvrAozvLN/d7973b2ad0f9b25f2f07d7d7439eebf2/image.png"
                          }
                      },
                      {
                          "sys": {
                              "id": "2wGVVLzAoaFkM1u3eCC60t"
                          },
                          "profileImage": null,
                          "name": "Dominik Harz",
                          "twitter": "https://x.com/dominik0_",
                          "company": "BOB",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Screenshot_2025-05-11_at_16.51.47_6b1llBf.png"
                      },
                      {
                          "sys": {
                              "id": "3ca72Dzrub0GA4oZ7S0gAD"
                          },
                          "profileImage": null,
                          "name": "Janmajaya mall",
                          "twitter": "https://github.com/Janmajayamall, https://x.com/Janmajaya_mall",
                          "company": "Phantom Zone",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/IMG_0883_2_dF6f6DN.jpeg"
                      },
                      {
                          "sys": {
                              "id": "28PCFGsfH7d4YrmWdHPQAz"
                          },
                          "profileImage": null,
                          "name": "Oliver Zrno",
                          "twitter": "https://www.linkedin.com/in/ozrno/",
                          "company": "FINREG PARTNERS",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/IMG_0082_2NDf9OB.jpg"
                      },
                      {
                          "sys": {
                              "id": "3CGZC06jhjeQs2OXJTjn3A"
                          },
                          "profileImage": null,
                          "name": "Joan de Ramon Brunet",
                          "twitter": "https://x.com/joan_drb",
                          "company": "Celo EU, Vocdoni, dOrg",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/IMG_20240603_235851_852_ALNi8z1.jpg"
                      },
                      {
                          "sys": {
                              "id": "1hIQhMHfdVcWKaE9n5vWtU"
                          },
                          "profileImage": null,
                          "name": "Elias Tazartes",
                          "twitter": "https://www.linkedin.com/in/elias-tazartes-a13450155",
                          "company": "Kakarot",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/linkedinimg_DLOTTsb.jpeg"
                      },
                      {
                          "sys": {
                              "id": "11jvUBr60ptn6Ujcj7Gm1x"
                          },
                          "profileImage": null,
                          "name": "Michel Abdalla",
                          "twitter": "https://www.linkedin.com/in/michel-abdalla-6a01a726",
                          "company": "Nexus",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/2022-07-Michel_shsYPHX.jpg"
                      },
                      {
                          "sys": {
                              "id": "wa3atwZUqav2TZiDtvL9k"
                          },
                          "profileImage": null,
                          "name": "Orest Tarasiuk",
                          "twitter": "https://x.com/OrestTa",
                          "company": "𝚝𝟷",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/1._Orest_DmEvNMz.jpg"
                      },
                      {
                          "sys": {
                              "id": "5JIk6NbhH9KrP68VSR6M66"
                          },
                          "profileImage": null,
                          "name": "Pierre Urban",
                          "twitter": "https://www.linkedin.com/in/pierre-urban-a892a6b5/",
                          "company": "GOODGOOD",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://wwnaig4uxpsv2a3sfy2masqibhgq44e3jlewejhoegjcn646gw6a.arweave.net/tZoEG5S75V0Dci40wEoICc0OcJtKyWIk7iGSJvueNbw"
                      },
                      {
                          "sys": {
                              "id": "6vYxF0fF5QJAwm9nGjpWsc"
                          },
                          "name": "Baki Er",
                          "twitter": "https://x.com/LibraryDefi",
                          "company": "Clave",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://y3umkdbimk4xezzbthiwmxz4h5tyvo3yccrpswzgif5q6pkygcua.arweave.net/xujFDChiuXJnIZnRZl88P2eKu3gQovlbJkF7Dz1YMKg",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "5cX3o0N656YNeaJuVW09W6"
                          },
                          "profileImage": null,
                          "name": "Isla",
                          "twitter": "https://x.com/0xisla",
                          "company": "Zuitzerland",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/1sla.eth_U9vv9uu.jpg"
                      },
                      {
                          "sys": {
                              "id": "69Cm4oZKjrxF3YYj2gIpTC"
                          },
                          "profileImage": null,
                          "name": "Peter Jung",
                          "twitter": "https://jung.ninja ",
                          "company": "Gnosis",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/IMG_1215_2_LOT0sdX.jpg"
                      },
                      {
                          "sys": {
                              "id": "3IBrKVEGpNQLhqySkIfeaB"
                          },
                          "profileImage": null,
                          "name": "Janmajaya mall",
                          "twitter": "https://github.com/Janmajayamall",
                          "company": "Phantom Zone",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/IMG_0883_2_dF6f6DN.jpeg"
                      },
                      {
                          "sys": {
                              "id": "72t6mR13xzinWPPB8GJyBP"
                          },
                          "profileImage": null,
                          "name": "Yaniv Tal",
                          "twitter": "https://x.com/yanivgraph",
                          "company": "Geo, The Graph",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Yaniv_Tal_Headshot_3M7G83F.png"
                      },
                      {
                          "sys": {
                              "id": "g2GwIIYomHDnQotaZ1tj1"
                          },
                          "profileImage": null,
                          "name": "Veronika Civinova",
                          "twitter": "https://cz.linkedin.com/in/veronika-civinova",
                          "company": "KLB Legal",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/GFXX2141_edit_78kb_k0jOrda.jpg"
                      },
                      {
                          "sys": {
                              "id": "5phXb297X5v0UfZ1i0jVJi"
                          },
                          "profileImage": null,
                          "name": "Valentin Boureaud",
                          "twitter": "https://github.com/VBoureaud",
                          "company": "Institute for Technology and Humanity ",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/7798126_9DOC5W4.jpeg"
                      },
                      {
                          "sys": {
                              "id": "2Bo3gmjTNnrUJKdAjUXvKH"
                          },
                          "profileImage": null,
                          "name": "Yudi",
                          "twitter": "https://x.com/yudixu",
                          "company": "Detrip",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/IMG_2597_IZyZg8C.JPG"
                      },
                      {
                          "sys": {
                              "id": "ozan-polat"
                          },
                          "name": "Ozan Polat",
                          "twitter": "https://www.linkedin.com/in/ozan-polat-987a214b/",
                          "company": "Judge",
                          "role": [
                              "judge"
                          ],
                          "profileImageUrl": "/people-and-sponsors/Ozan_Polat.jpg",
                          "profileImage": null
                      },
                      {
                          "sys": {
                              "id": "1Jy1y84YnHVVVqy7cNBIi8"
                          },
                          "profileImage": null,
                          "name": "Mely.eth",
                          "twitter": "https://x.com/mely_jpg",
                          "company": "ENS Labs ",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/I77GRoAb_400x400_wbsg7B2.jpg"
                      },
                      {
                          "sys": {
                              "id": "1Km7sOJx23VHxShMQ2JtWx"
                          },
                          "profileImage": null,
                          "name": "Karam Alhamad (Zendetta)",
                          "twitter": "https://www.linkedin.com/in/zendetta/",
                          "company": "Web3 Foundation",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/photo_2025-04-29_21.27.08_aiE8tQy.jpeg"
                      },
                      {
                          "sys": {
                              "id": "bjPrAy5nj5NRzyKucjIMP"
                          },
                          "profileImage": null,
                          "name": "Anthurine Xiang",
                          "twitter": "https://x.com/qc_qizhou",
                          "company": "QuarkChain",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/6174452071881884266_wVeNfpk.jpg"
                      },
                      {
                          "sys": {
                              "id": "4OWzKe5bgQPhiguCSP9Dyh"
                          },
                          "profileImage": null,
                          "name": "Daniel Vaculík",
                          "twitter": "https://www.linkedin.com/in/daniel-vaculik",
                          "company": "Digital and information agency Czechia",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/4932_JlMQyVr.jpg"
                      },
                      {
                          "sys": {
                              "id": "1ZxSLBI5P1nGBaMUx9NA7A"
                          },
                          "profileImage": null,
                          "name": "Dorian Vincileoni",
                          "twitter": "https://www.linkedin.com/in/dorian-vincileoni-30550196/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
                          "company": "KuCoin",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://pbs.twimg.com/profile_images/1654088477372211200/CABJnaxW_400x400.jpg"
                      },
                      {
                          "sys": {
                              "id": "5LT7GXxpDzFk0Wl4gFX1RX"
                          },
                          "profileImage": null,
                          "name": "George Kobakhidze",
                          "twitter": "https://x.com/sick_nerdballer",
                          "company": "Consensys Diligence, EEA",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/george_Gp3i5da.jpg"
                      },
                      {
                          "sys": {
                              "id": "4QARLEcvq0YOGtSicOLxoy"
                          },
                          "profileImage": null,
                          "name": "Alexander Forshtat",
                          "twitter": "https://github.com/forshtat",
                          "company": "ERC-4337",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Alexander_Forshtat_z0ep45O.jpg"
                      },
                      {
                          "sys": {
                              "id": "1JoIolZdDZDtUZz9w9FTbw"
                          },
                          "profileImage": null,
                          "name": "Sasha Tanase Luca",
                          "twitter": "https://x.com/sasha_tanases",
                          "company": "Thesis, Mezo Network, Web3UX",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/2023-03-05_19.10.27_amr5rkV.jpg"
                      },
                      {
                          "sys": {
                              "id": "7iXYZoPtRn02RXXONG9Nw"
                          },
                          "profileImage": null,
                          "name": "Antoine Sparenberg",
                          "twitter": "https://x.com/asparenb",
                          "company": "Argent",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Duo_4848_5OjwpbN.jpg"
                      },
                      {
                          "sys": {
                              "id": "3zwhuqCCgMkm2ymMWvqeNq"
                          },
                          "profileImage": null,
                          "name": "Lorenz Lehmann",
                          "twitter": "https://x.com/LehmannLorenz",
                          "company": "growthepie.xyz ",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/IMG_6914_szKCYa8.jpeg"
                      },
                      {
                          "sys": {
                              "id": "20f1aUNErfoxaKNNycWFUD"
                          },
                          "profileImage": null,
                          "name": "Eomji Park",
                          "twitter": "https://x.com/eomjipark",
                          "company": "Encode Club ",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/EP2_D0IQGkL.jpg"
                      },
                      {
                          "sys": {
                              "id": "4hIvKa0Ni1tJsGKM2F2ASM"
                          },
                          "profileImage": null,
                          "name": "Pietro Carta",
                          "twitter": "https://x.com/ptrcarta?lang=en",
                          "company": "ChainSecurity",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Screenshot_2025-05-11_at_16.50.09_XeSirE2.png"
                      },
                      {
                          "sys": {
                              "id": "58kC7Bg7ALTiivTllEsMq2"
                          },
                          "profileImage": null,
                          "name": "Inna Vladimirovna Osetrova",
                          "twitter": "https://www.linkedin.com/in/innaosetrova1111/",
                          "company": "The Institute of World Politics ",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/IMG_5712_epbxjSU.JPG"
                      },
                      {
                          "sys": {
                              "id": "4my8yFOyucSiU5MarNGCg7"
                          },
                          "profileImage": null,
                          "name": "Filip Rezabek",
                          "twitter": "https://x.com/rezabfil?lang=en",
                          "company": "TUM, SpaceComputer",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/RezabekProfilePhoto_Jeuh0Tm.png"
                      },
                      {
                          "sys": {
                              "id": "QGu9jw3S3h78zKfeB7MGx"
                          },
                          "profileImage": null,
                          "name": "Dalibor Cerny",
                          "twitter": "https://www.linkedin.com/in/cernydalibor/",
                          "company": "The New Story",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/normal_dalibor_HQ_wIwOndF.jpg"
                      },
                      {
                          "sys": {
                              "id": "2DDZ85nKvB8xL1UQnc3pcW"
                          },
                          "profileImage": null,
                          "name": "Benjamin J. Richter",
                          "twitter": "https://www.linkedin.com/in/webquake/",
                          "company": "Google",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/21a853155f4e271c9983db240119b1d5_j8Myezv.png"
                      },
                      {
                          "sys": {
                              "id": "3PMgnabTdwUR1GLcOjX5NM"
                          },
                          "profileImage": null,
                          "name": "Mariia Yatskovska",
                          "twitter": "https://x.com/MariiaYatskovs2",
                          "company": "CoW DAO",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Photo_Mariia_NCuecCy.jpg"
                      },
                      {
                          "sys": {
                              "id": "7oBFjFVgVN4y5B8NAzT3ZG"
                          },
                          "profileImage": null,
                          "name": "Alon Muroch",
                          "twitter": "https://x.com/ammuroch",
                          "company": "SSV Network",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/1_R48SSfB.png"
                      },
                      {
                          "sys": {
                              "id": "4CqLDTrPFal7Yz69zq1zc2"
                          },
                          "profileImage": null,
                          "name": "Louis Bellet",
                          "twitter": "https://x.com/0xYellow",
                          "company": "Yellow",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/2025-05-05_17.32.43_0E25geY.jpg"
                      },
                      {
                          "sys": {
                              "id": "qpKxghTF4JqUCuWWYixyT"
                          },
                          "profileImage": null,
                          "name": "Michal Převrátil",
                          "twitter": "https://x.com/michprev",
                          "company": "Ackee Blockchain Security",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/6698e34420c31a5547621585_Michal-p-500_RcUTn0b.jpg"
                      },
                      {
                          "sys": {
                              "id": "2TOySsBMk3HJFOfJDu3Bc1"
                          },
                          "profileImage": null,
                          "name": "Oleksandr Kurbatov",
                          "twitter": "https://x.com/olkurbatov",
                          "company": "Rarimo",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/ok_photo_j1WgH1x.jpg"
                      },
                      {
                          "sys": {
                              "id": "5vc9iGtr4l2CT58AWH9UYU"
                          },
                          "profileImage": null,
                          "name": "Sandi Fatic",
                          "twitter": "https://x.com/chefsale?lang=en",
                          "company": "Calimero",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://pbs.twimg.com/profile_images/1943369169983897600/viSzCgPP_400x400.jpg"
                      },
                      {
                          "sys": {
                              "id": "58Zzpn0rBVfLdWnKp6uFyu"
                          },
                          "profileImage": null,
                          "name": "Shaka Lei Kaumaka",
                          "twitter": "https://x.com/shakaleikaumaka?lang=en",
                          "company": "The Open-Source Orchestra",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/IMG_3014_n5cCTQ0.JPG"
                      },
                      {
                          "sys": {
                              "id": "54VHyhiakyyvLJb8NKTP8"
                          },
                          "profileImage": null,
                          "name": "Naoki Yoshida",
                          "twitter": "https://x.com/meditationduck",
                          "company": "Ackee Blockchain Security",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/MyYabaiyatu_kRq5bQL.jpeg"
                      },
                      {
                          "sys": {
                              "id": "47y5HBmZW1jVjrFgofQTA"
                          },
                          "profileImage": null,
                          "name": "jchetrit.eth",
                          "twitter": "https://x.com/josepchetrit12",
                          "company": "OpenZeppelin",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/dM8b3TM0_400x400_8We6JzE.jpg"
                      },
                      {
                          "sys": {
                              "id": "HiDLRCd019cwDrO2p5snq"
                          },
                          "profileImage": null,
                          "name": "Ben",
                          "twitter": "https://x.com/web3benx",
                          "company": "BNB",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/5848059721599273168_uwuYaUm.jpg"
                      },
                      {
                          "sys": {
                              "id": "6s3MWXFb6dIN6T7frLCMGJ"
                          },
                          "profileImage": null,
                          "name": "Leo Sizaret",
                          "twitter": "https://x.com/sizero_",
                          "company": "StarkWare",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/for_loyal_member_copy_TLlBshL.png"
                      },
                      {
                          "sys": {
                              "id": "2EqUkfJlCzCg4gINUX7VwZ"
                          },
                          "profileImage": null,
                          "name": "Jan Pabisiak",
                          "twitter": null,
                          "company": null,
                          "role": [
                              "speaker",
                              "mentor"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/DSC_2246_2_0DqNk8z.jpg"
                      },
                      {
                          "sys": {
                              "id": "2mkGgkQ1wEC4ULW0frq04l"
                          },
                          "profileImage": null,
                          "name": "Puncar",
                          "twitter": "https://x.com/PuncarH2D",
                          "company": "How To DAO, HelloMotherAI, WorkoutDAO",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/PFP_inUE8MU.jpeg"
                      },
                      {
                          "sys": {
                              "id": "1wOWwRHORuRDtmb1cFqREb"
                          },
                          "profileImage": null,
                          "name": "Guil. Sperb Machado",
                          "twitter": "https://x.com/gsmachado",
                          "company": "AxLabs",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/guil-machado-head_Q6dKWO7.png"
                      },
                      {
                          "sys": {
                              "id": "TaxeSJ4059RRgFxYczYBI"
                          },
                          "profileImage": null,
                          "name": "Jakub Jedlinský",
                          "twitter": "https://cz.linkedin.com/in/jjedlinsky",
                          "company": "Altlift",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Jakub-orez-final-1-400x400_L52amVn.png"
                      },
                      {
                          "sys": {
                              "id": "2H4M3FvjKQXEgk4QXa2yHl"
                          },
                          "profileImage": null,
                          "name": "Vlad Costea",
                          "twitter": "https://x.com/thevladcostea",
                          "company": "Bitcoin Takeover Podcast",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/5861533759856298270_PtDDCRy.jpg"
                      },
                      {
                          "sys": {
                              "id": "6bJezms8VKRfXkAKTNu2Fi"
                          },
                          "profileImage": null,
                          "name": "Ilie (Elijah) Puscas",
                          "twitter": "https://x.com/Puskiilie",
                          "company": "Binance",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Ilie-Puscas-2-1-Photoroom_gkPnQd9.jpg"
                      },
                      {
                          "sys": {
                              "id": "31WYgsRpKLEt2piHg1iRiI"
                          },
                          "profileImage": null,
                          "name": "Naim Ashhab",
                          "twitter": "https://x.com/ashhanai",
                          "company": "PWN DAO",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/IMG_5467_TKLpuTV.jpg"
                      },
                      {
                          "sys": {
                              "id": "7tOpmoXGruSNTqgkwpYj1x"
                          },
                          "profileImage": null,
                          "name": "Skas",
                          "twitter": "https://github.com/Skanislav",
                          "company": "PWNDAO",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/IMG_0169_if7XzcB.jpg"
                      },
                      {
                          "sys": {
                              "id": "2qs6Q2aKfS1e8B9PhejYkO"
                          },
                          "profileImage": null,
                          "name": "Loring Harkness",
                          "twitter": "https://x.com/loringharkness",
                          "company": "Shutter Network, Paddle Battle",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Loring_3mIQLVS.jpeg"
                      },
                      {
                          "sys": {
                              "id": "5u6ikwQgJon79CH7gFAfoS"
                          },
                          "profileImage": null,
                          "name": "Solange Gueiros",
                          "twitter": "https://x.com/solangegueiros",
                          "company": "Chainlink Labs",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/SolangeGueiros-Azul02_Ih4ohAw.jpg"
                      },
                      {
                          "sys": {
                              "id": "3faEIaVtZL9e7azvIhhS1l"
                          },
                          "profileImage": null,
                          "name": "Eniko",
                          "twitter": "x.com/eenagy",
                          "company": "EthNodes",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/17G-AAQx_400x400_5DQQo7X.jpg"
                      },
                      {
                          "sys": {
                              "id": "zfvYYAbv7i28oUv31fGFZ"
                          },
                          "profileImage": null,
                          "name": "Nico Gallardo",
                          "twitter": "https://x.com/nicnode",
                          "company": "Octant",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Nico-pfp_sH9DPkw.jpeg"
                      },
                      {
                          "sys": {
                              "id": "2c1HCEZgswkrUq1jGd7EFr"
                          },
                          "profileImage": null,
                          "name": "Casey Carr",
                          "twitter": "https://x.com/solardank",
                          "company": "Diffractions Collective, Civilisational Resilience",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/solardank_CQgZ20l.png"
                      },
                      {
                          "sys": {
                              "id": "1dQZhr0KCSdaOa0LmrABAl"
                          },
                          "profileImage": null,
                          "name": "Ivan Homoliak",
                          "twitter": "https://www.linkedin.com/in/ivan-homoliak-381117185/",
                          "company": "Brno University of Technology",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/fit-prednaska-habilitacia_iB1s45f_yQRvAaI.png"
                      },
                      {
                          "sys": {
                              "id": "2tgsE3FxElM9alAfusURBf"
                          },
                          "profileImage": null,
                          "name": "Ilija Rilakovic",
                          "twitter": "https://x.com/LawyerWooden",
                          "company": "LawDecoded and EthBelgrade",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://pbs.twimg.com/profile_images/1588251066440769537/a7JiOmpI_400x400.jpg"
                      },
                      {
                          "sys": {
                              "id": "4Elbvw5GG2ZXw7nwFWajsh"
                          },
                          "profileImage": null,
                          "name": "Aleksandr Kuperman",
                          "twitter": "https://x.com/kupermind?lang=en",
                          "company": "Olas",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/370a688d7d9c07aae541dfd53d07cef2_TYgnBVd.png"
                      },
                      {
                          "sys": {
                              "id": "79pFQ4bFZjVDFMC8T9IUH2"
                          },
                          "profileImage": null,
                          "name": "Rémi",
                          "twitter": "https://x.com/rems000",
                          "company": "Self",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/IMG_0166_kzn0UlP.jpeg"
                      },
                      {
                          "sys": {
                              "id": "6sTffCmY0m7PsQnsVO4sVG"
                          },
                          "profileImage": null,
                          "name": "Victor",
                          "twitter": "https://x.com/starkience",
                          "company": "Starkware",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/D2C7425D-AE68-43E6-9274-A309681CBCA6_FAVcoBO.jpeg"
                      },
                      {
                          "sys": {
                              "id": "5wgNlWASCBhhkpUPPITN6T"
                          },
                          "profileImage": null,
                          "name": "Maciej Kalka",
                          "twitter": "https://x.com/Mojtek",
                          "company": "Vlayer Labs",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/photo_2025-03-07_00.29.49_fqwpPqa.jpeg"
                      },
                      {
                          "sys": {
                              "id": "3gYdeZSWLXyFysFL335jHs"
                          },
                          "profileImage": null,
                          "name": "Pavel Bautista",
                          "twitter": "https://www.linkedin.com/in/pavelbautista/",
                          "company": "MigaLabs",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Pavel_z4x5ut0.jpeg"
                      },
                      {
                          "sys": {
                              "id": "shbAM5fKYoVkmr0ucmB6o"
                          },
                          "profileImage": null,
                          "name": "Benjamin Kraner",
                          "twitter": "www.linkedin.com/in/benjamin-kraner-983387194",
                          "company": "UZH Blockchain Center",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/5868610238167500611_z5fKiW1.jpg"
                      },
                      {
                          "sys": {
                              "id": "2v7Kl19QLI8gvrRo022qBc"
                          },
                          "profileImage": null,
                          "name": "Radim Kozub",
                          "twitter": "https://www.linkedin.com/in/radim-kozub-4728a2133",
                          "company": "Blockchain Legal",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/2022-08-22-Portrety-Blockchain-Legal-POZADI-0008_cXkOSX7.jpg"
                      },
                      {
                          "sys": {
                              "id": "7rlgnMUG09SbiBMhRuzp4p"
                          },
                          "profileImage": null,
                          "name": "James Ross",
                          "twitter": "https://x.com/jrosstreacher",
                          "company": "Mode Network",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://pbs.twimg.com/profile_images/1038426325353226240/W7JHSlJo_400x400.jpg"
                      },
                      {
                          "sys": {
                              "id": "6x3dg37MCsybCqsGp3cp56"
                          },
                          "profileImage": null,
                          "name": "Colin",
                          "twitter": "https://x.com/bookof_eth?s=21",
                          "company": "The Book Of Ethereum",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/image0-5_F4PuXcH.jpeg"
                      },
                      {
                          "sys": {
                              "id": "VgWKdLFwQnEvVWplzCoXO"
                          },
                          "profileImage": null,
                          "name": "Jose Ramirez",
                          "twitter": "https://x.com/jozer_eth",
                          "company": "Palmera",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/josepalmeradao.xyz_363-min_hDoWSQe.jpg"
                      },
                      {
                          "sys": {
                              "id": "24RSN44yf93IzxYxd13Zg7"
                          },
                          "profileImage": null,
                          "name": "Jordan Sutcliffe",
                          "twitter": "https://x.com/JstarCS",
                          "company": "Symbiotic",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Staking_Summit_2024_Jordan_Speaker_Photo_1_Medium_pJkgedY.JPG"
                      },
                      {
                          "sys": {
                              "id": "5wRA7E0CYln4ygPDrB0jEO"
                          },
                          "profileImage": null,
                          "name": "Artur Sychov",
                          "twitter": "https://x.com/ASychov",
                          "company": "Somnium Space, Authencity.io",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/EB80DE44-B49E-4D1D-9084-4CB2B39F5407_1_102_o_fH7yBPJ.jpeg"
                      },
                      {
                          "sys": {
                              "id": "1xJq08ZSu1Mi2EUOVc5NKx"
                          },
                          "profileImage": null,
                          "name": "marie ladrová",
                          "twitter": "https://marieladrova.com",
                          "company": null,
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/marie-la-atelier-edit_cYgFzDA.jpg"
                      },
                      {
                          "sys": {
                              "id": "6b3dQYZgE10tLA1rREgigB"
                          },
                          "profileImage": null,
                          "name": "Kristian Kostal",
                          "twitter": "https://www.linkedin.com/in/kristi%C3%A1n-ko%C5%A1%C5%A5%C3%A1l-9599a82b5/ ",
                          "company": "Slovak University of Technology",
                          "role": [
                              "mentor"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Kristian_Kostal_cropped_WinxpAg.jpg"
                      },
                      {
                          "sys": {
                              "id": "7DpUUwPHlN8QXD3wHeI1Wa"
                          },
                          "profileImage": null,
                          "name": "Milan \"Sodomák\" Půlkrábek",
                          "twitter": "https://x.com/sodomak",
                          "company": "Digitální Sebeobrana ",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/self-bw-to-ascii2_RGUw5wf.jpg"
                      },
                      {
                          "sys": {
                              "id": "2FuAv2dYvTovF5nF5xLi3Q"
                          },
                          "profileImage": null,
                          "name": "Cedric Maloux",
                          "twitter": "https://x.com/cedricmaloux",
                          "company": "StartupYard",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Cedric_Maloux_Je5OPu3.jpg"
                      },
                      {
                          "sys": {
                              "id": "4iOZfXcIQ9gseKTcswGvQ7"
                          },
                          "profileImage": null,
                          "name": "Patrik Nový",
                          "twitter": "https://www.linkedin.com/in/patriknovy/?originalSubdomain=cz",
                          "company": "KB SmartSolutions",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Patrik_Novy_N7DfjZR.jpg"
                      },
                      {
                          "sys": {
                              "id": "kyiRLXjnAhRSnfkSjxnq6"
                          },
                          "profileImage": null,
                          "name": "Michal Ciffra",
                          "twitter": "https://www.linkedin.com/in/michalciffra/?originalSubdomain=cz ",
                          "company": "The Fintechers ",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Michal_Ciffra_TgIzK78.jpg"
                      },
                      {
                          "sys": {
                              "id": "x6XYXa8HMLkjPeQ4prPeh"
                          },
                          "profileImage": null,
                          "name": "Monika Sillova",
                          "twitter": "https://moncisillova.wixsite.com/portfolio",
                          "company": "mar.s architects",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/1636975598184_0rv93cI.jpeg"
                      },
                      {
                          "sys": {
                              "id": "4NniHsi00Ta9E0nVeNKge7"
                          },
                          "profileImage": null,
                          "name": "Krzysztof Urbański",
                          "twitter": "https://x.com/kaereste",
                          "company": "L2BEAT",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/oszhJE6V_400x400_rmMk19x.jpg"
                      },
                      {
                          "sys": {
                              "id": "5YTVtwTnR3aUACaq2BmfAp"
                          },
                          "profileImage": null,
                          "name": "Marek Olszewski",
                          "twitter": "https://x.com/marek_",
                          "company": "Celo",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Bhp4_Il2_400x400_bG0PEoL.jpg"
                      },
                      {
                          "sys": {
                              "id": "5vhEyt31eb6xwEbvWl3FAV"
                          },
                          "profileImage": null,
                          "name": "Hubert Kotlinski",
                          "twitter": "https://x.com/hubkotl",
                          "company": "L2BEAT",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/isbm5xlw_400x400_JX7W313.jpg"
                      },
                      {
                          "sys": {
                              "id": "5OKgGSdG04SQbBEJ36hQJ4"
                          },
                          "profileImage": null,
                          "name": "Ileana Lobkowicz",
                          "twitter": "https://www.lobkowicz.cz/",
                          "company": "House of Lobkowicz",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Screenshot_2025-05-24_at_12.53.52_RtsLC1a.png"
                      },
                      {
                          "sys": {
                              "id": "7kz3pQfRLK97rxEbWnBEel"
                          },
                          "profileImage": null,
                          "name": "Daniel Nagy",
                          "twitter": null,
                          "company": null,
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/signal-2025-05-22-214026_T0eSoHw.jpeg"
                      },
                      {
                          "sys": {
                              "id": "3qYGP3p1g7DbK7ikmeYY9X"
                          },
                          "profileImage": null,
                          "name": "Etienne Waldron",
                          "twitter": "https://x.com/ledger",
                          "company": "Ledger",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Etienne_Waldron_profile_1_dQZHzjW.jpg"
                      },
                      {
                          "sys": {
                              "id": "2YRQgp7GUZYBPKxPqtVG9V"
                          },
                          "profileImage": null,
                          "name": "Friederike Ernst",
                          "twitter": "https://x.com/tw_tter?lang=en",
                          "company": "Gnosis, Circles ",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/FErnst_gFPKbAH.jpeg"
                      },
                      {
                          "sys": {
                              "id": "5pm71UCG9z2Chg26kGXzBu"
                          },
                          "profileImage": null,
                          "name": "Lena Hierzi",
                          "twitter": "https://x.com/GigaHierz",
                          "company": "Celo",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/lena_hierzi_avatar_jlLCQpr.jpg"
                      },
                      {
                          "sys": {
                              "id": "4WAyXrrjwY6f8Y7AmD0DGL"
                          },
                          "profileImage": null,
                          "name": "Francesco Andreoli",
                          "twitter": "https://x.com/francescoswiss",
                          "company": "MetaMask",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/francesco_o6GWpIY.jpeg"
                      },
                      {
                          "sys": {
                              "id": "6VsBlZqJ2ihQVoIbjMz7Za"
                          },
                          "profileImage": null,
                          "name": "Philippe",
                          "twitter": "https://github.com/philogy/",
                          "company": "Sensei Lang",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/phil2025_-_1_5mb_1wItmG0.jpg"
                      },
                      {
                          "sys": {
                              "id": "5PP2QGmLog0nWlf6zXg2j1"
                          },
                          "profileImage": null,
                          "name": "Oana Barbu",
                          "twitter": "https://x.com/OanaDesu",
                          "company": "Sensei Lang",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/profile_pic_-_Copy_F2OBdwa.jpg"
                      },
                      {
                          "sys": {
                              "id": "6Cb8TGitWtPz1HgOzSrpWz"
                          },
                          "profileImage": null,
                          "name": "Vojtěch Luxemburk",
                          "twitter": "https://iprpraha.cz/en/",
                          "company": "IPR",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/Screenshot_2025-05-25_at_16.55.28_7pOG1ZH.png"
                      },
                      {
                          "sys": {
                              "id": "5vNbfnkhBgcGJjM23C5MCw"
                          },
                          "profileImage": null,
                          "name": "Sebastian Kugler",
                          "twitter": "https://github.com/sekuba",
                          "company": "L2BEAT",
                          "role": [
                              "speaker"
                          ],
                          "profileImageUrl": "https://cfp.ducttape.events/media/avatars/webu_A7uGo6Q.jpg"
                      },
                    //   {
                    //     "sys": {
                    //         "id": "5vNbfnkhBgcGJjM23C5MCw12"
                    //     },
                    //     "profileImage": null,
                    //     "name": "Tears",
                    //     "twitter": null,
                    //     "company": "",
                    //     "role": [
                    //         "speaker"
                    //     ],
                    //     "profileImageUrl": "tears.jpg"
                    // },
                      {
                        "sys": {
                            "id": "5vNbfnkhBgcGJjM23C5MCw10"
                        },
                        "profileImage": null,
                        "name": "Andy",
                        "twitter": null,
                        "company": '',
                        "role": [
                            "speaker"
                        ],
                        "profileImageUrl": "Andy.jpg"
                        },
                      {
                        "sys": {
                            "id": "5vNbfnkhBgcGJjM23C5MCw1"
                        },
                        "profileImage": null,
                        "name": "Anne-Grace Kleczewski",
                        "twitter": null,
                        "company": '',
                        "role": [
                            "speaker"
                        ],
                        "profileImageUrl": "Anne-Grace-Kleczewski.jpg"
                    },
                    {
                        "sys": {
                            "id": "5vNbfnkhBgcGJjM23C5MCw2"
                        },
                        "profileImage": null,
                        "name": "Damsky",
                        "twitter": null,
                        "company": '',
                        "role": [
                            "speaker"
                        ],
                        "profileImageUrl": "damsky.png"
                    },
                    {
                        "sys": {
                            "id": "5vNbfnkhBgcGJjM23C5MCw3"
                        },
                        "profileImage": null,
                        "name": "Dmytro Khimchenko",
                        "twitter": null,
                        "company": "Ackee Blockchain Security",
                        "role": [
                            "speaker"
                        ],
                        "profileImageUrl": "Dmytro_Khimchenko.jpeg"
                    },
                    {
                        "sys": {
                            "id": "5vNbfnkhBgcGJjM23C5MCw4"
                        },
                        "profileImage": null,
                        "name": "Arik Galansky",
                        "twitter": null,
                        "company": "Fireblocks",
                        "role": [
                            "speaker"
                        ],
                        "profileImageUrl": "Arik_Galansky.png"
                    },
                    {
                        "sys": {
                            "id": "5vNbfnkhBgcGJjM23C5MCw5"
                        },
                        "profileImage": null,
                        "name": "Dennison Bertram",
                        "twitter": null,
                        "company": "Tally.xyz",
                        "role": [
                            "speaker"
                        ],
                        "profileImageUrl": "Dennison_Bertram.jpeg"
                    },
                  ]
              }
          }
      ]
  },
  "ethPragueSponsorOrPartnerSorted2025Collection": {
      "items": [
          {
              "ethPragueSponsorOrPartnerCollection": {
                  "items": [
                      {
                          "logo": null,
                          "name": "World",
                          "logoUrl": "https://bw5ymkkjgqvqmrt6v5se6q7y2kew4jycvqkikferyew64c277mlq.arweave.net/DbuGKUk0KwZGfq9kT0P40oluJwKsFIUUkcEt7gtf-xc",
                          "link": "https://world.org/",
                          "tier": "sun"
                      },
                      {
                          "logo": null,
                          "name": "Polkadot",
                          "logoUrl": "https://e72qjtslsgzyi2qrbi3erlph3uyubr4zxusbbknuqdae43aydisa.arweave.net/J_UEzkuRs4RqEQo2SK3n3TFAx5m9JBCptIDATmwYGiQ",
                          "link": "https://polkadot.com/",
                          "tier": "sun"
                      },
                      {
                          "logo": null,
                          "name": "Google Cloud",
                          "logoUrl": "https://www.gstatic.com/cgc/google-cloud-logo.svg",
                          "link": "https://cloud.google.com",
                          "tier": "beam"
                      },
                      {
                          "logo": null,
                          "name": "Ledger",
                          "logoUrl": "https://vzi54uj2x5nqiv6gk2pwo5trhslhquhkti2zpdbq36obqbknamgq.arweave.net/rlHeUTq_WwRXxlafZ3ZxPJZ4UOqaNZeMMN-cGAVNAw0",
                          "link": "https://www.ledger.com/",
                          "tier": "gardener"
                      },
                      {
                          "logo": null,
                          "name": "The Fin Techers",
                          "logoUrl": "https://2grsnzb7c3xojl2iygaum4yl334vipdrwo6rjk46aghilpx2v6da.arweave.net/0aMm5D8W7uSvSMGBRnML3vlUPHGzvRSrngGOhb76r4Y",
                          "link": "https://thefintechers.com/",
                          "tier": "local partner"
                      },
                      {
                          "name": "PWN",
                          "logoUrl": "https://ocvrbqljhizcxqirsj62edmeofzhr5p2wfrtgk3iz2zriw6ipc4a.arweave.net/cKsQwWk6MivBEZJ9og2EcXJ49fqxYzMraM6zFFvIeLg",
                          "link": "https://pwn.xyz/",
                          "tier": "beam",
                          "logo": null
                      },
                      {
                          "name": "Arthapala",
                          "logoUrl": "https://wqqjpkwkogfueqaantoiv3ihmhbtekuus3qhpeg3tbd3jc6xck6q.arweave.net/tCCXqspxi0JAAGzciu0HYcMyKpSW4HeQ25hHtIvXEr0",
                          "link": "https://arthapala.vc/",
                          "tier": "photon",
                          "logo": null
                      },
                      {
                          "name": "VSE",
                          "logoUrl": "https://pbkhtx5sq4jrtkhuerk75vpui7bkzy3doppudgz6sagn3hxdhcta.arweave.net/eFR537KHExmo9CRV_tX0R8Ks42Nz30GbPpAM3Z7jOKY",
                          "link": "https://www.vse.cz/english/",
                          "tier": "local partner",
                          "logo": null
                      },
                      {
                          "name": "esp",
                          "logoUrl": "https://uaivkvezpu5k3tc7j2ucirgsyku6o3n7h55ftz5ugcz7i5ijawuq.arweave.net/oBFVVJl9Oq3MX06oJETSwqnnbb8_elnntDCz9HUJBak",
                          "link": "https://esp.ethereum.foundation/",
                          "tier": "beam",
                          "logo": null
                      },
                      {
                          "name": "Starkware",
                          "logoUrl": "https://sxhg6mdc5mqzo5zns3sgm6s7h7vt3kgfzn4i6txdrpgturgbnl7q.arweave.net/lc5vMGLrIZd3LZbkZnpfP-s9qMXLeI9O44vNOkTBav8",
                          "link": "https://starkware.co/",
                          "tier": "sun",
                          "logo": null
                      },
                      {
                          "name": "FEL",
                          "logoUrl": "https://xcqp4peb3im7wr5dhbk742e2kifckluxf6dhgzdiqhu5bexo77oq.arweave.net/uKD-PIHaGftHozhV_miaUgolLpcvhnNkaIHp0JLu_90",
                          "link": "https://fel.cvut.cz/en",
                          "tier": "local partner",
                          "logo": null
                      },
                      {
                          "name": "Technical University of Munich",
                          "logoUrl": "https://qvy66qwnzpz33uhhgfwtzlnk2jmh4o4755jeqz6sute2fq4rg2jq.arweave.net/hXHvQs3L873Q5zFtPK2q0lh-O5_vUkhn0qTJosORNpM",
                          "link": "https://www.tum.de/en/",
                          "tier": "local partner",
                          "logo": null
                      },
                      {
                          "name": "UZH Blockchain Center",
                          "logoUrl": "https://iqhdf4el6opyfjtj2t7x64reomfnrszg3qj73dhzpitattpbvcpq.arweave.net/RA4y8Ivzn4KmadT_f3IkcwrYyybcE_2M-XomCc3hqJ8",
                          "link": "https://www.blockchain.uzh.ch/",
                          "tier": "local partner",
                          "logo": null
                      },
                      {
                          "name": "EigenLayer",
                          "logoUrl": "https://dtpacdu4sjr55jhlc5c7pdsevjwui3yjnb35wil2xiqyxhkse2ta.arweave.net/HN4BDpySY96k6xdF945Eqm1Ebwlod9sherohi51SJqY",
                          "link": "https://www.eigenlayer.xyz/",
                          "tier": "photon",
                          "logo": null
                      },
                      {
                          "name": "FIT Brno",
                          "logoUrl": "https://bgkys5rswjygplc3brbmlts6zg4cm2umkvxn27l6fielae2dlrja.arweave.net/CZWJdjKycGesWwxCxc5eybgmaoxVbt19fioIsBNDXFI",
                          "link": "https://www.fit.vut.cz/.en",
                          "tier": "local partner",
                          "logo": null
                      },
                      {
                          "logo": null,
                          "name": "WIA",
                          "logoUrl": "https://wia.cz/wp-content/themes/wia/gfx/logo/wia.png",
                          "link": "https://wia.cz/en/",
                          "tier": "local partner"
                      },
                      {
                          "logo": null,
                          "name": "Circles",
                          "logoUrl": "https://wvwqbmfh54ajwsdy2gbqldxtssjjiuzcpijzwrwv67udnuzhm5ta.arweave.net/tW0AsKfvAJtIeNGDBY7zlJKUUyJ6E5tG1ffoNtMnZ2Y",
                          "link": "https://aboutcircles.com/",
                          "tier": "beam"
                      },
                      {
                          "logo": null,
                          "name": "Akahasha - Sponsor - gardener",
                          "logoUrl": "https://y3nkcdfh2rayhus4o34odj6zdewnx2rzodbq47x26szkowql3imq.arweave.net/xtqhDKfUQYPSXHb44afZGSzb6jlwww5--vSyp1oL2hk",
                          "link": "https://akasha.org/",
                          "tier": "gardener"
                      },
                      {
                          "logo": null,
                          "name": "Celo - Sponsor - Beam",
                          "logoUrl": "https://d7girtiupmvtbqcm6a2gfbfhnwyludv6huyxkue6x32jqrbdvqfq.arweave.net/H8yIzRR7KzDATPA0YoSnbbC6Dr49MXVQnr70mEQjrAs",
                          "link": "https://celo.org/",
                          "tier": "beam"
                      },
                      {
                          "logo": null,
                          "name": "Celo Europe - Sponsor - Photon",
                          "logoUrl": "https://2dbmxtmwdgwsnpclzk5xrvybzyj625xzzfab553zouc2mblbzmzq.arweave.net/0MLLzZYZrSa8S8q7eNcBzhPtdvnJQB73eXUFpgVhyzM",
                          "link": "https://www.celoeu.org/",
                          "tier": "photon"
                      },
                      {
                          "logo": null,
                          "name": "C-labs - Sponsor - Photon",
                          "logoUrl": "https://rzxfpf3mtltlfyrlu32b7n4r2hgcxtq4urgppkg2gsqmo4jbio2a.arweave.net/jm5Xl2ya5rLiK6b0H7eR0cwrzhykTPeo2jSgx3EhQ7Q",
                          "link": "https://clabs.co/",
                          "tier": "photon"
                      },
                      {
                          "logo": null,
                          "name": "Self - Sponsor - Photon",
                          "logoUrl": "https://nb3zzu6vpllyqu6e5kev2qvfhotuhmrueridmpmvzvdam2bvnz2a.arweave.net/aHec09V614hTxOqJXUKlO6dDsjQkUDY9lc1GBmg1bnQ",
                          "link": "https://self.xyz/",
                          "tier": "photon"
                      },
                      {
                          "logo": null,
                          "name": "Zircuit - Sponsor - Gardener",
                          "logoUrl": "https://2pwzikzh24udgwimafjgxwjfk43smaods4ipi4wb3rw3vhfbcjeq.arweave.net/0-2UKyfXKDNZDAFSa9klVzcmAcOXEPRywdxtupyhEkk",
                          "link": "https://www.zircuit.com/",
                          "tier": "gardener"
                      },
                      {
                          "logo": null,
                          "name": "ITU Blockchain",
                          "logoUrl": "https://6hvc3eflzykmgezkokdgh5tqauqgcmvduznhxl5syftk7y7ijt5a.arweave.net/8eotkKvOFMMTKnKGY_ZwBSBhMqOmWnuvssFmr-PoTPo",
                          "link": "https://www.itublockchain.com/",
                          "tier": "local partner"
                      },
                      {
                          "logo": null,
                          "name": "StreamETH",
                          "logoUrl": "https://fbtfkoyx2xr2euzdgmm7fojkrm6ymtuey33ixhzpr3oaqvyhskha.arweave.net/KGZVOxfV46JTIzMZ8rkqiz2GToTG9oufL47cCFcHko4",
                          "link": "https://info.streameth.org/",
                          "tier": "gardener"
                      },
                      {
                          "logo": null,
                          "name": "SSV - Sponsor - Gardener",
                          "logoUrl": "https://gcmvlulbqflyz75dmfby3upssdxqjrqzxnoyifl3co6t2ql4f4ga.arweave.net/MJlV0WGBV4z_o2FDjdHykO8Exhm7XYQVexO9PUF8Lww",
                          "link": "https://ssvlabs.io/",
                          "tier": "gardener"
                      },
                      {
                          "logo": null,
                          "name": "Ola - Sponsor - Gardener",
                          "logoUrl": "https://pbncxasszq4iyu6bxlu435riiyqk6fh5dojwlq2gjcqnc3fz6npa.arweave.net/eForglLMOIxTwbrpzfYoRiCvFP0bk2XDRkig0Wy5814",
                          "link": "https://olas.network/",
                          "tier": "gardener"
                      },
                      {
                          "logo": null,
                          "name": "Yellow - Sponsor - Beam",
                          "logoUrl": "https://2huz32lrvy7o4xy5djbnwofwmxsoys5w2vgpllxump25yd7llola.arweave.net/0emd6XGuPu5fHRpC2zi2ZeTsS7bVTPWu9GP13A_rW5Y",
                          "link": "https://www.yellow.org/",
                          "tier": "beam"
                      },
                      {
                          "logo": null,
                          "name": "Scope - sponsor - gardener",
                          "logoUrl": "https://egf3w66m37ylpoqytisfrugcbiourmlep6yhkfebdv2b4uc5tmya.arweave.net/IYu7e8zf8Le6GJokWNDCCh1IsWR_sHUUgR10HlBdmzA",
                          "link": "https://www.scope.cz/",
                          "tier": "gardener"
                      },
                      {
                          "logo": null,
                          "name": "Calimero - Sponsor - Gardener",
                          "logoUrl": "https://gstmyiplrdqzcvgyrxsoyqjljqe4w436ptrt4fi2rrg3oeriovia.arweave.net/NKbMIeuI4ZFU2I3k7EErTAnLc3584z4VGoxNtxIodVA",
                          "link": "https://calimero.network/",
                          "tier": "gardener"
                      },
                      {
                          "logo": null,
                          "name": "TUM ",
                          "logoUrl": "https://o2aueqqp7xzste7eytl5fpnn5v36fhlqt7as4oyat36jjifkbchq.arweave.net/doFCQg_98ymT5MTX0r2t7XfinXCfwS47AJ78lKCqCI8",
                          "link": "https://www.tum-blockchain.com/",
                          "tier": "local partner"
                      },
                      {
                          "logo": null,
                          "name": "Vitra",
                          "logoUrl": "https://76xtzqsvaw7pzhjeyprsiupzeate7xvkwfbja4aaywkwm5vhx43q.arweave.net/_688wlUFvvydJMPjJFH5ICZP3qqxQpBwAMWVZnanvzc",
                          "link": "https://www.vitra.com/en-cz/home",
                          "tier": "local partner"
                      },
                      {
                          "logo": null,
                          "name": "Ackee",
                          "logoUrl": "https://oc4cvlpzkfi6xy3clz52jbik6ezjoqdawj2swjj32bkqn4euahiq.arweave.net/cLgqrflRUevjYl57pIUK8TKXQGCydSslO9BVBvCUAdE",
                          "link": "https://www.ackee.agency/",
                          "tier": "gardener"
                      },
                      null,
                      {
                          "logo": null,
                          "name": "Symbiotic - Sponsor - Photon",
                          "logoUrl": "https://tt74axd2bxfus3hstp7muej22hrndnmx44u2pzahq5tsb6h3ehoa.arweave.net/nP_AXHoNy0ls8pv-yhE60eLRtZfnKafkB4dnIPj7Idw",
                          "link": "https://symbiotic.fi/",
                          "tier": "photon"
                      },
                      {
                          "logo": null,
                          "name": "Book of ETH - Sponsor - Photon",
                          "logoUrl": "https://wndernmxisveahwa73wtqii7me6eg6a2ec6fae6g2fgnizqav3ya.arweave.net/s0ZItZdEqkAewP7tOCEfYTxDeBogvFATxtFM1GYArvA",
                          "link": "https://www.bookofeth.xyz/",
                          "tier": "photon"
                      },
                      {
                          "logo": null,
                          "name": "Kokoza - partner",
                          "logoUrl": "https://ptrsoay23hxl6o4qkufqo66tnvwfdocboshmj6cb5lhq3pehyhwq.arweave.net/fOMnAxrZ7r87kFULB3vTbWxRuEF0jsT4QerPDbyHwe0",
                          "link": "https://kokoza.cz/",
                          "tier": "local partner"
                      },
                      {
                          "logo": null,
                          "name": "Kraken - Sponsor - Sun",
                          "logoUrl": "https://qpz7mgsvkinmvaykftl5cfrk62p7l6h55p47vsd4sm6dtow4nulq.arweave.net/g_P2GlVSGsqDCizX0RYq9p_1-P3r-frIfJM8ObrcbRc",
                          "link": "https://www.kraken.com/",
                          "tier": "sun"
                      },
                      {
                          "logo": null,
                          "name": "Wired - Media Partner",
                          "logoUrl": "https://vnhsgh7pzkblrs3z2gb5hupcubopptndm2htblwwz2dzviilzmxa.arweave.net/q08jH-_KgrjLedGD09HioFz3zaNmjzCu1s6HmqELyy4",
                          "link": "https://www.wired.com/",
                          "tier": "media partner"
                      },
                      {
                          "logo": null,
                          "name": "Rekola - Partner",
                          "logoUrl": "https://frishnpkm2vjublqzc7pznivrlasrnbnop2o4kr6pedsef7txika.arweave.net/LFEjtepmqpoFcMi-_LUVisEotC1z9O4qPnkHIhfzuhQ",
                          "link": "https://www.rekola.cz/en/",
                          "tier": "local partner"
                      },
                      {
                          "logo": null,
                          "name": "BNB Chain - Sponsor - Gardener",
                          "logoUrl": "https://z4zoouhaitvuupdmwggdwmnsyyhvoqvfwlk4ccqa3bujuz3rxsgq.arweave.net/zzLnUOBE60o8bLGMOzGyxg9XQqWy1cEKANhommdxvI0",
                          "link": "https://www.bnbchain.org/",
                          "tier": "gardener"
                      }
                  ]
              }
          }
      ]
  }
}